
<div class="keep-offer-dialog">

  <div class="content"><h1 >Mettre à jour mes infos</h1>
  <form #dealerEditForm="ngForm" class="dealer-edit-form">

    <mat-form-field >
      <mat-label>Civilité</mat-label>
      <mat-select matNativeControl  required name = "civility" [(ngModel)] = "data.civility">
        @for (t of civilities; track t) {
          <mat-option [value]="t"> {{t}} </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label>Vous etes un(e)</mat-label>
      <mat-select matNativeControl  required name = "dealerType" [(ngModel)] = "data.dealerType">
        @for (t of dealerTypes; track t) {
          <mat-option [value]="t"> {{t}} </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label>Prénom</mat-label>
      <input required type="text" matInput="" name ="fname" placeholder="First Name"  [(ngModel)]="data.firstName" >
    </mat-form-field>

    <mat-form-field >
      <mat-label>Nom</mat-label>
      <input type="text" matInput="" name ="lname" placeholder="Last Name"  [(ngModel)]="data.lastName" >
    </mat-form-field>

    <mat-form-field >
      <mat-label>Nom d'entreprise</mat-label>
      <input [required]="data.dealerType === 'PROFESSIONAL'" type="text" matInput="" name ="businessName" placeholder="Business Name"  [(ngModel)] = "data.businessName" >
    </mat-form-field>

    @if (data.dealerType === 'PROFESSIONAL') {
      <mat-form-field >
        <mat-label>Forme d'entreprise</mat-label>
        <mat-select [required]="data.dealerType === 'PROFESSIONAL'" matNativeControl  name = "businessType" [(ngModel)]="data.businessType">
          @for (t of businessTypes; track t) {
            <mat-option [value]="t"> {{t}} </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <!-- <mat-form-field >
    <mat-label>Indicatif pays</mat-label>
    <input type="number" matInput="" required name ="phoneCode"  [(ngModel)]="data.phoneCode" >
  </mat-form-field> -->

  <mat-form-field >
    <mat-label>Indicatif pays</mat-label>
    <mat-select required matNativeControl name = "phoneCode" [(ngModel)]="data.phoneNumber.code">
      @for (country of countries; track country) {
        <mat-option [value]="country.phoneCode"> +{{country.phoneCode}} ({{country.name}})</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field >
    <mat-label>Numéro de téléphone</mat-label>
    <input type="number" matInput="" [pattern]="phoneNumberRegex" required name ="phoneNumber"  [(ngModel)]="data.phoneNumber.number" #phoneNumber="ngModel">

    @if (phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)) {
      <span class="error-alert">
        @if (phoneNumber.errors?.['required']) {
          <span>
            Le numéro est requis.
          </span>
        }
        @if (phoneNumber.errors?.['pattern']) {
          <span>
            Numéro non valide
          </span>
        }
      </span>
    }
  </mat-form-field>

  <mat-form-field >
    <mat-label>Email</mat-label>
    <input type="text" matInput="" [pattern]="emailRegex" required name ="email"  [(ngModel)]="data.email" #email="ngModel">

    @if (email.invalid && (email.dirty || email.touched)) {
      <span class="error-alert">
        @if (email.errors?.['required']) {
          <span>
            Email est requis.
          </span>
        }
        @if (email.errors?.['pattern']) {
          <span>
            Email non valide
          </span>
        }
      </span>
    }

  </mat-form-field>

  <mat-form-field >
    <mat-label>Pays de Residence</mat-label>
    <mat-select required matNativeControl name = "countryResident" [(ngModel)]="data.countryResident">
      @for (country of countries; track country) {
        <mat-option [value]="country.code"> {{country.name}} </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field >
    <mat-label>Ville de Residence</mat-label>
    <mat-select required matNativeControl name = "cityResident" [(ngModel)]="data.cityResident">
      @for (city of getCitiesforCountry(data.countryResident); track city) {
        <mat-option [value]="city"> {{city}} </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field >
    <mat-label>Pays d'origine</mat-label>
    <mat-select required matNativeControl name = "countryOrigin" [(ngModel)]="data.countryOrigin">
      @for (country of countries; track country) {
        <mat-option [value]="country.code"> {{country.name}} </mat-option>
      }
    </mat-select>
  </mat-form-field>


  <!--
  <br />

  <mat-radio-group
    aria-labelledby="example-radio-group-label" class="example-radio-group" name="dealerType" [(ngModel)] = "data.dealerType">
    <mat-radio-button class="example-radio-button" *ngFor="let type of dealerTypes; index as i"  [value]="type">
      {{type}}
    </mat-radio-button>
  </mat-radio-group>

  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <mat-form-field >
    <mat-label>First Registration</mat-label>
    <input type="number" matInput="" name ="firstRegistration" placeholder="First Registration" >
  </mat-form-field>

  <p style="color: orange">{{ formMessage }} and  {{ data.dealerType}}</p>


  <p> {{!updateMode ? "Create new car"  : "Update car Infos" }}
    <button (click) = "toggleMode()" class="link" >{{updateMode ? "Show body type"  : "Hide body type" }}</button>

  </p>
  -->
</form>

<div class="action-buttons">
  <button class="simple-button-buy" mat-button [mat-dialog-close]="">Cancel</button>
  <button class="cta-button-buy" [disabled] = !dealerEditForm.valid mat-button [mat-dialog-close]="data" cdkFocusInitial> Save </button>
</div>
</div>